import {timeFormat, numberFormat} from "@custom/index";
import {conversionAmount} from "@/utils/hooks";

//2022/03/27 王江毅 工单管理 工单列表
export function tableWorkOrderColumn(that) {
    return [
        {
            prop: "wordNum",
            label: "工单编号",
            width: 150
        },
        {
            label: "处理状态",
            width: 150,
            prop:'statusName',
        },
        {
            label: "租客名字",
            width: 100,
            render: (h, {row}) => {
                const {leasorName} = row;
                return h("el-link", {
                    props: {type: "primary", underline: false},
                    on: {
                        click() {
                            that.$router.push({name: "tenant-management", params: {data: {leasorName}}});
                        }
                    }
                }, leasorName);
            }
        },
        {
            label: "房源地址",
            width: 200,
            render: (h, {row}) => {
                const {apartmentName} = row;
                return h("el-link", {
                    props: {type: "primary", underline: false},
                    on: {
                        click() {
                            that.$router.push({name: "house-resource", query: {data: {apartmerntName: apartmentName}}});
                        }
                    }
                }, apartmentName);
            }
        },
        {
            prop: "wordType",
            label: "业务类型",
            width: 100,
        },
        {
            prop: "submitter",
            label: "提交人",
            width: 100,
        },
        {
            label: "申请时间",
            render: (h, {row}) => {
                const {applyTime} = row;
                return applyTime ? timeFormat(new Date(row.applyTime)) : "";
            }
        },
        {
            label: "提交时间",
            render: (h, {row}) => {
                const {createDate} = row;
                return createDate ? timeFormat(new Date(createDate), "yyyy-MM-dd HH:mm:ss") : "";
            }
        },
        {
            label: "处理时间",
            render: (h, {row}) => {
                const {updateTime} = row;
                return updateTime ? timeFormat(new Date(updateTime), "yyyy-MM-dd HH:mm:ss") : "";
            }
        },
        {
            label: "总额",
            render: (h, {row}) => {
                const {total} = row;
                return total > 0 ? "收取" + numberFormat(total / 100) : "退还" + numberFormat((-total) / 100);
            }
        },
        {
            prop: "comment",
            label: "备注",
            showOverflowTooltip: true,
        },
    ];
}